export { background } from "@seneca/senekit";

export const linearGradient = (angle: number, colours: string) =>
  `linear-gradient(${angle}deg, ${colours})`;

export const withHoverAndActiveStates = (
  hoverColor: string,
  activeColor: string
) => {
  return `
    :hover{
      background:${hoverColor}
    }
    :active{
     background:${activeColor}
    }
    `;
};
